import { usePlatform } from '../../business/context/platform-context'
import { jwtService } from '@zeus/react-common/lib/business/service/jwt-service'
import { accessTokenService } from '@zeus/react-common/lib/business/service/token/access-token-service'
import { browserUtil } from '@zeus/react-common/lib/util/browser-util'
import React, { useState } from 'react'
import { Container } from 'react-bootstrap'
import eyeqlogo from 'src/asset/image/eyeqmarketplace-logo.svg'
import zeusLogo from 'src/asset/image/logo-dark.svg'
import { authServiceFactory } from 'src/business/service/auth-service'
import style from 'src/screen/not-verified-screen/not-verified-screen.module.scss'
import { toasterUtil } from 'src/util/toaster-util'

export const NotVerifiedScreen = (): React.ReactElement => {
  const [verificationTriggered, setVerificationTriggered] = useState(false)
  const { isEyeQMarketplace } = usePlatform()

  accessTokenService
    .get()
    .then((token) => {
      try {
        const { v2, tenant } = jwtService.decode(token)
        if (v2?.user.isEmailVerified) browserUtil.redirect(`/${tenant?.type}`)
      } catch (e) {
        browserUtil.redirect('/v2/auth/login')
      }
    })
    .catch(() => browserUtil.redirect('/v2/auth/login'))
  const handleResendCode = async (): Promise<void> => {
    try {
      await authServiceFactory().verifyEmailResend()
      setVerificationTriggered(true)
    } catch (e) {
      toasterUtil.error(`Error sending verification email, please try again.`)
    }
  }

  const email = isEyeQMarketplace ? 'SupplierSupport@Wincanton.co.uk' : 'customerservice@zeuslabs.com'

  const currentLogo = isEyeQMarketplace ? eyeqlogo : zeusLogo

  return (
    <>
      <Container fluid={true} className={`vh-100 ${style.bgGray}`}>
        <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-between">
          <div className={`d-flex align-items-center justify-content-center ${style.w60} mt-5`}>
            <img className={style.logo} src={currentLogo} alt={'Zeus'} />
          </div>
          <div className={`d-flex flex-column align-items-center justify-content-center ${style.w60} pt-5`}>
            <p className="font-21 color-dark-blue font-700 w-100 text-center">Verify your email address</p>
            <p className="font-14 color-dark-blue w-50 text-center pt-2 pb-5">
              {verificationTriggered
                ? 'Check your inbox! We have re-sent the verification link to your email account.'
                : `To complete your sign up process and start partnering with ${
                    isEyeQMarketplace ? 'Eye Q' : 'Zeus'
                  }, you need to verify your email address. In case you haven't received the email, please click below.`}
            </p>
            {!verificationTriggered && (
              <p className={`button-round-large`} onClick={handleResendCode}>
                Resend Verification Email
              </p>
            )}
          </div>
          <div className={`d-flex flex-column align-items-center justify-content-center ${style.w60} pt-3 mb-5`}>
            <div className="font-14 color-dark-blue text-center">
              We are happy to assist you with any queries you may have regarding our product.
            </div>
            <div className="font-14 color-dark-blue text-center">
              You can reach us by email at&nbsp;
              <a className="font-14 color-sky-blue" href={`mailto:${email}`}>
                {email}
              </a>
              {isEyeQMarketplace ? null : (
                <>
                  &nbsp;or by phone at&nbsp;
                  <a className="font-14 color-dark-blue" href="tel:+44-0-20-3608-0043">
                    +44 (0)20 3608 0043
                  </a>
                </>
              )}
              .
            </div>
          </div>
        </div>
      </Container>
    </>
  )
}
